import React, {useEffect} from 'react'
import {Banner, AboutBox, Gallery2, Counters, Rooms, Services, Testimonials, Blog} from '../../Components/Home'
import gallery from '../../Constants/gallery'
import rooms from '../../Constants/rooms'
import services from '../../Constants/services'
import testimonials from '../../Constants/testimonials'
import posts from '../../Constants/posts'


function Home() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    return (
      <>
        {/* // <!-- banner --> */}
        <Banner/>
        {/* // <!-- banner end --> */}

        {/* <!-- about --> */}
        <AboutBox />
        {/* <!-- about end --> */}



        {/* <Gallery items={gallery.slice(0,8)} /> */}



        {/* <!-- gallery --> */}
        <Gallery2 items={gallery.slice(0,8)}/>
        {/* <!-- gallery end --> */}

        {/* <!-- counters --> */}
        <Counters />
        {/* <!-- counters end --> */}

        {/* <!-- rooms --> */}
        <Rooms items={rooms.slice(0,8)}/>
        {/* <!-- rooms end --> */}

        {/* <!-- services --> */}
        <Services items={services} />
        {/* <!-- services end --> */}

        {/* <!-- testimonials --> */}
        <Testimonials items={testimonials} />
        {/* <!-- testimonials end --> */}

        {/* <!-- blog --> */}
        <Blog items={posts.slice(0,3)}/>
        {/* <!-- blog end --> */}
      </>
    
    )
}

export default Home